import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useWcdModel } from "../wcdModel";

export function PageHeader () {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useWcdModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "报关单号",
            fieldName: "prescoCode",
        },
        {
            type: SearchTypeEnum.Datepicker,
            placeholder: "报关日期",
            fieldName: "createTime",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "预警状态",
            fieldName: "warningType",
            options:getSelectedDictOne(DictCodeEnmu.WARNING)
        },
    ]

    return (
        <YhPageHeader
            title="报关单预警列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}